import React, { useState } from "react";
import { TIDS } from "@/constants/testIds";

export default function AgeGate({ onPass }) {
  const [dob, setDob] = useState("");
  const [attested, setAttested] = useState(false);
  const [error, setError] = useState("");

  const calcAge = (d) => {
    if (!d) return 0;
    const dt = new Date(d);
    const now = new Date();
    let age = now.getFullYear() - dt.getFullYear();
    const m = now.getMonth() - dt.getMonth();
    if (m < 0 || (m === 0 && now.getDate() < dt.getDate())) age--;
    return age;
  };

  const confirm = () => {
    const age = calcAge(dob);
    if (!dob) return setError("Enter your date of birth");
    if (!attested) return setError("Confirm you are 18 or older");
    if (age < 18) return setError("You must be 18+ to enter StreamCast");
    localStorage.setItem("sc_age_ok", "1");
    onPass();
  };

  const exit = () => {
    window.location.href = "https://www.google.com";
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center" style={{ background: "rgba(0,0,0,0.85)", backdropFilter: "blur(24px)" }}>
      <div className="glass max-w-md w-[92%] p-8 rounded-md relative">
        <div className="sc-label text-[#FF3366]">Restricted Access</div>
        <h2 className="sc-heading text-4xl font-black mt-2 mb-3 leading-none">Welcome to MystiCast</h2>
        <p className="text-sm text-zinc-400 mb-6">
          MystiCast is an 18+ live streaming and gaming community. Verify your age to enter.
        </p>

        <label className="sc-label block mb-2">Date of Birth</label>
        <input
          data-testid={TIDS.ageGateDob}
          type="date"
          value={dob}
          onChange={(e) => setDob(e.target.value)}
          className="sc-input mb-4"
        />

        <label className="flex items-start gap-3 text-sm text-zinc-300 cursor-pointer mb-2">
          <input
            data-testid={TIDS.ageGateAttest}
            type="checkbox"
            checked={attested}
            onChange={(e) => setAttested(e.target.checked)}
            className="mt-1 accent-[#FF3366]"
          />
          <span>I confirm I am at least 18 years of age and accept the Terms of Service.</span>
        </label>

        {error && <div className="text-[#FF3366] text-xs mt-2">{error}</div>}

        <div className="flex gap-3 mt-6">
          <button data-testid={TIDS.ageGateConfirm} className="sc-btn flex-1" onClick={confirm}>Enter MystiCast</button>
          <button data-testid={TIDS.ageGateExit} className="sc-btn-ghost" onClick={exit}>Exit</button>
        </div>
      </div>
    </div>
  );
}
